import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import './Footer.scss'
import { withRouter } from 'react-router';
import { changeLanguage, getTranslations } from '../../actions/UserActions';
import OpenTime from "../OpenTime/OpenTime";
import { Link } from 'react-router-dom'

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flag: "",
      tabIndex: 0,
    };
  }

  onChangeLanguage = (lang) => {
    this.props.dispatch(getTranslations(lang)).then(() => {
      this.props.dispatch(changeLanguage(lang));
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="footer-wrap footer-margin">
          <Row>
            <Col lg={3} md={4} sm={6} xs={12}>
              <div style={{ lineHeight: 1.5 }}>
                <p><img
                  src="../../../assets/images/logo-footer.png"
                  alt=""
                  className="footer-logo"
                /></p>
                <div style={{ color: "White", fontSize: '1.23rem', margin: '-20px 0 20px 30px', }} >
                  <div className="no-margin">Gruppenpraxis Neuhard</div>
                  <p>Neuhardstr. 38, 4600 Olten </p>
                  <div>Tel. 062 296 50 55</div>
                  <div><a href="mailto:gruppenpraxis.neuhard@hin.ch" style={{ color: '#ffffff' }}>gruppenpraxis.neuhard@hin.ch</a></div>
                  {/* <Link to="/dataPrivacy"> Datenschutzerklärung </Link> */}
                </div>
                
              </div>
            </Col>
            <Col lg={1} md={1} sm={1} xs={1} className="no-padding"></Col>
            <Col lg={8} md={12} sm={12} xs={12}>
              <div style={{ lineHeight: 1.5, color: "White", fontSize: '1.2rem' }}>
                <ul className="time-list languages-list">
                  <li>{this.props.loadTranslations('ÖFFUNUNGSZEITEN', this.props.currentLanguage)}</li>
                </ul>
                <hr className="Ftext-subline" />
                <Row>
                  <Col lg={6} md={6} sm={12} xs={12} className="no-padding border-right">
                    <Row className="margin-bottom10">
                      <Col lg={12} md={12} sm={12} xs={12} className="np-left">
                        <h5 style={{ color: '#ffffff' }}>
                          Als Gruppenpraxis bieten wir folgende Öffnungszeiten an:
                        </h5>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12} className="np-left">
                        <p>Montag-Freitag</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={6} className="np-left">
                        <p>7.30 - 12.00 Uhr</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={6} className="np-left">
                        <p>13.30 - 18.00 Uhr</p>
                      </Col>
                    </Row>
                    {/* <Row>
                      <Col lg={4} md={4} sm={6} xs={12} className="np-left">
                        <p>Donnerstag</p>
                      </Col>
                      <Col lg={4} md={4} sm={6} xs={12} className="np-left">
                        <p>7.30 - 12.00 Uhr</p>
                      </Col>
                    </Row> */}

                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12} className="np-left">
                        <p>Samstag</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={12} className="np-left">
                        <p>7.30 - 12.00 Uhr</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={12} />
                    </Row>
                  </Col>
                  <Col lg={6} md={6} sm={12} xs={12} className="np-left">
                    <Row className="margin-bottom10">
                      <Col lg={8} md={8} sm={7} xs={12} className="np-left p-left">
                        <h5 style={{ color: '#ffffff' }}>Telefonische Erreichbarkeit:</h5>
                      </Col>
                      <Col lg={4} md={4} sm={5} xs={12} className="np-right p-left">
                        {/* <h4 className="nm-top" style={{ color: '#ffffff' }}>Tel. 062 296 50 55</h4> */}
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12} className="np-left p-left">
                        <p>Montag-Mittwoch</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={6} className="np-left">
                        <p>8.00 - 11.30 Uhr</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={6} className="np-left">
                        <p>13.30 - 17.00 Uhr</p>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12} className="np-left p-left">
                        <p>Donnerstag</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={6} className="np-left">
                        <p> 8.00 - 11.30 Uhr</p>
                      </Col>

                    </Row>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12} className="np-left p-left">
                        <p>Freitag</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={6} className="np-left">
                        <p>8.00 - 11.30 Uhr</p>
                      </Col>
                      <Col lg={4} md={4} sm={6} xs={6} className="np-left">
                        <p>13.30 - 16.30 Uhr</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={6} />
                    </Row>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12} className="np-left p-left">
                        <p>Samstag</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={6} className="np-left">
                        <p>8.00 - 10.00 Uhr</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={6} />
                    </Row>
                    <Row>
                      <Col
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className="text-center"
                      ></Col>
                    </Row>
                  </Col>
                </Row>
                {/* <Row className="footer-time-wrap">
                    <Col lg={6} md={6} sm={12} xs={12} className="np-left">
                      <h5>Sprechstunden:</h5>
                      <h6>MO - FR 7.30 - 12.00 und 13.30 - 18.00</h6>
                      <h6>SA 7.30 - 12.00</h6>
                    </Col>
                    <Col lg={6} md={6} sm={12} xs={12} className="np-left">
                      <h5>Telefonische Erreichbarkeit:</h5>
                      <h6>MO - DO 8.00 - 11.30 und 13.30 - 17.00</h6>
                      <h6>FR 8.00 - 11.30 und 13.30 - 16.30</h6>
                      <h6>SA 8.00 - 10.00</h6>
                    </Col>
                    <Col lg={6} md={6} sm={12} xs={12} className="np-left">
                      <h5>Termine nach Vereinbarung</h5>
                    </Col>
                  </Row> */}
              </div>
            </Col>
            {/* <Col lg={1} md={1} sm={6} xs={12}> </Col> */}
            {/* <Col lg={5} md={5} sm={6} xs={12}>
              <div>
                <ul className="languages-list">
                  <li>{this.props.loadTranslations('Unsere Angebote', this.props.currentLanguage)}</li>
                  <hr className="Ftext-subline" />
                  <li onClick={() => this.props.router.push("/medizinisches")}><i class="fas fa-caret-right" /> {this.props.loadTranslations('Medizinische Grundversorgung', this.props.currentLanguage)}</li>
                  <li onClick={() => this.props.router.push("/physiotherapie")}><i class="fas fa-caret-right" /> {this.props.loadTranslations('Physiotherapie', this.props.currentLanguage)}</li>
                  <li onClick={() => this.props.router.push("/ernahrungsberatung")}><i class="fas fa-caret-right" /> {this.props.loadTranslations('Ernährungsberatung', this.props.currentLanguage)}</li>
                  <li onClick={() => this.props.router.push("/sonographie")}><i class="fas fa-caret-right" /> {this.props.loadTranslations('Sonographie', this.props.currentLanguage)}</li>
                  <li onClick={() => this.props.router.push("/venensprechstunde")}><i class="fas fa-caret-right" /> {this.props.loadTranslations('Venensprechstunde', this.props.currentLanguage)}</li>
                  <li onClick={() => this.props.router.push("/notfall")}><i class="fas fa-caret-right" /> {this.props.loadTranslations('Notfall', this.props.currentLanguage)}</li>
                  <li onClick={() => this.props.router.push("/impressionenPraxis")}><i class="fas fa-caret-right" /> {this.props.loadTranslations('Impressionen Praxis', this.props.currentLanguage)}</li>
                  <li onClick={() => this.props.router.push("/news")}><i class="fas fa-caret-right" /> {this.props.loadTranslations('News', this.props.currentLanguage)}</li>
                </ul>

              </div>
            </Col> */}
          </Row>
          <Row>
            <Col lg={12} md={12} sm={12} xs={12} className='text-center'>
              <hr />
              <ul className='footer-links'>
                <li />
                <li onClick={() => this.props.router.push("/aboutUs")}>Über uns</li>
                <li><srong>|</srong></li>
                <li onClick={() => this.props.router.push("/ourTeam")}>Team</li>
                <li><srong>|</srong></li>
                <li onClick={() => this.props.router.push("/dataPolicy")}>Data Policy</li>
                <li><srong>|</srong></li>
                <li onClick={() => this.props.router.push("/contactUs")}>Kontakt</li>
              </ul>
            </Col>
          </Row>
        </div>
        <div className="text-center" style={{ background: '#395261', padding: '15px 0' }}>
          <h5 style={{ color: '#ffffff', fontWeight: 'normal', margin: '0px' }}>Copyright &#169; 2024 gruppenpraxis. Powered by &nbsp;
            <a href="http://wensdigital.com/#/Main/" style={{ color: 'White' }}>WENS Digital GmbH</a> | www.wensdigital.com
          </h5>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentLanguage: state.users.currentLanguage
  };
}

export default connect(mapStateToProps)(withRouter(Footer));



// WEBPACK FOOTER //
// ./screens/Footer/Footer.js